import classNames from "classnames";
// import { Form } from "react-bootstrap";
// import { Dropdown } from "components/Dropdown";

// import { iconArrowDown } from "assets/icons/strategy";
import { TooltipIcon } from "./TooltipIcon";
import { getBrokerIcon, getStatusColor } from "utils";
import { StrategyAction } from "features/Strategy/v2/List/Action";

export const tableColumns = (
  handlePauseStrategy,
  handleStopStrategy,
  handleStartStrategy,
  // handleSelectAll,
  // selectAll,
  // onRowCheckboxChange,
  handleChangeAllocationAmount,
  handleManageAllocation,
  theme
) => [
  // {
  //   dataField: "id",
  //   text: "Action",
  //   props: {
  //     cell: (data) => (
  //       <div className="selection-wrapper">
  //         <Form.Check
  //           type="checkbox"
  //           lable=""
  //           checked={data.row.original.selected}
  //           onChange={(e) => onRowCheckboxChange(e, data.row.original)}
  //         />
  //       </div>
  //     ),
  //   },
  // },

  {
    dataField: "broker_account_nickname",
    text: "Name",
    props: {
      cell: (data) => {
        const {
          eligibility_message,
          broker_account_nickname,
          eligible,
          logo_url,
          broker_name,
        } = data.row.original;
        return (
          <div className="name-icon-wrapper">
            <div>
              <img
                src={getBrokerIcon(logo_url, theme)}
                className="icon-broker"
              />
            </div>
            <div
              className={classNames({
                "eligibility-space": !eligible,
              })}
            >
              {broker_account_nickname}
              <span className="broker-sub-text">{broker_name}</span>

              <div className="eligibility">{eligibility_message}</div>
            </div>
          </div>
        );
      },
    },
  },
  {
    dataField: "id",
    text: "Status",
    props: {
      cell: (data) => {
        const { subscription_status, eligible } = data.row.original;
        const color = getStatusColor(subscription_status, theme);
        return (
          eligible && (
            <div
              className={classNames({
                "eligibility-space": !eligible,
              })}
              style={{ color }}
            >
              {subscription_status}
            </div>
          )
        );
      },
    },
  },
  {
    dataField: "id",
    text: "Actions",
    props: {
      id: "action",
      cell: (rowData) => {
        const index = rowData.row.index;

        return (
          rowData.row.original.eligible && (
            <div
              className={classNames("btn-action", {
                "eligibility-space": !rowData.row.original.eligible,
              })}
            >
              <StrategyAction
                rowData={rowData.row.original}
                index={index}
                handleStopStrategy={handleStopStrategy}
                handleStartStrategy={handleStartStrategy}
                handlePauseStrategy={handlePauseStrategy}
                handleChangeAllocationAmount={handleChangeAllocationAmount}
                handleManageAllocation={handleManageAllocation}
              />
            </div>
          )
        );
      },
      header: () => {
        return (
          <div>
            Actions &nbsp;
            <TooltipIcon />
          </div>
        );
      },
    },
  },
];
